import yearbookSliceReducer from "./yearbook/yearbookSearchSlice";
import {configureStore} from "@reduxjs/toolkit";
import {yearbookSearchApi} from "../services/yearbookSearchService";

const store = configureStore({
        reducer: {
            yearbookSearch: yearbookSliceReducer,
            [yearbookSearchApi.reducerPath]: yearbookSearchApi.reducer
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(yearbookSearchApi.middleware)
        }
);

export default store;
